interface CreativeLoadingScreenProps {
  message?: string;
  submessage?: string;
  showProgress?: boolean;
  progress?: number;
}

export function CreativeLoadingScreen({
  message = 'Loading...',
  submessage = 'Preparing your workspace',
  showProgress = false,
  progress = 0,
}: CreativeLoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center max-w-sm mx-auto p-8">
        {/* Spinner */}
        <div className="relative mb-8 mx-auto w-12 h-12">
          <div className="w-12 h-12 border-2 border-border border-t-primary rounded-full animate-spin" />
        </div>

        {/* Loading Text */}
        <h2 className="text-lg font-semibold text-foreground mb-1">
          {message}
        </h2>
        <p className="text-sm text-muted-foreground">
          {submessage}
        </p>

        {/* Progress Bar */}
        {showProgress && (
          <div className="mt-6 w-full bg-muted rounded-full h-1.5 overflow-hidden">
            <div
              className="bg-primary h-1.5 rounded-full transition-all duration-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
